module.exports = __webpack_public_path__ + "img/red-2-squiggly-striped.3f21a8d8.svg";